import PlayerInformation from './playerInformation';
import './leftBodyCardTenis.sass';

/**
 * Muestra la información básica (nombre e imagen) de los dos jugadores de tenis (izquierda y derecha).
*/
export default function LeftBodyCardTenis({ data }) {
  const { left_image, left_name, right_image, right_name } = data;

  return (
    <div className="body-card-tenis__left">
      <PlayerInformation
        image={left_image}
        name={left_name}
        className="body-card-tenis__left-player-left"
      />

      <PlayerInformation
        image={right_image}
        name={right_name}
        className="body-card-tenis__left-player-right"
      />
    </div>
  );
}